



































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositBankSettings from '@/models/Products/ProductSettings/DefaultSettings/Banking/DepositBankSettings';
import DepositBankSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/Banking/DepositBankSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositBankSettingsRead', components: { ProductState, DepositBankSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositBankSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }

}
